/*
 * Toolworld – forsiden, tæt version (Johan 2026-10-24).
 * - Felt C "Mest købte": pillerne skifter liste uden at genindlæse siden. "Alle" står i HTML; en hovedgruppes liste
 *   hentes med Section Rendering API på L1'ens URL (?section_id=tw-fs-mest-koebte) – i baggrunden, når siden er færdig,
 *   så skiftet er øjeblikkeligt. Mobil: 6 varer + "Vis flere".
 * Felt E "Nyt i butikken" er ren HTML (kollektionen Nyheder + agentens forside-e, Johan 2026-10-24) – intet JS.
 * Uden JS: "Alle" vises, pillerne gør intet.
 */
(function () {
  'use strict';

  var idle = window.requestIdleCallback || function (fn) { return window.setTimeout(fn, 1200); };
  var efterLoad = function (fn) {
    if (document.readyState === 'complete') idle(fn);
    else window.addEventListener('load', function () { idle(fn); });
  };
  var hent = function (url, sectionId) {
    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', sectionId);
    return fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      return tmp;
    });
  };

  // ---------- Felt C: piller + "Vis flere" ----------
  document.querySelectorAll('[data-tw-fs-mest]').forEach(function (sek) {
    var paneler = sek.querySelector('[data-tw-fs-paneler]');
    var piller = sek.querySelectorAll('[data-tw-fs-pille]');
    var flere = sek.querySelector('[data-tw-fs-flere]');
    var henter = {};
    var panel = function (id) { return paneler.querySelector('[data-tw-fs-panel="' + id + '"]'); };
    var sikr = function (pille) {
      var id = pille.getAttribute('data-tw-fs-pille');
      if (panel(id)) return Promise.resolve(true);
      if (henter[id]) return henter[id];
      henter[id] = hent(pille.getAttribute('data-tw-fs-url'), 'tw-fs-mest-koebte').then(function (tmp) {
        var ul = tmp.querySelector('[data-tw-fs-panel]');
        if (!ul) throw new Error('mangler liste');
        ul.setAttribute('data-tw-fs-panel', id);
        ul.hidden = true;
        if (!panel(id)) paneler.appendChild(ul);
        return true;
      }).catch(function () { henter[id] = null; return false; });
      return henter[id];
    };
    var opdaterFlere = function () {
      if (!flere) return;
      var vist = paneler.querySelector('[data-tw-fs-panel]:not([hidden])');
      flere.hidden = !vist || vist.children.length <= 6;
    };
    var vis = function (pille) {
      var id = pille.getAttribute('data-tw-fs-pille');
      sikr(pille).then(function (ok) {
        if (!ok) return;
        paneler.querySelectorAll('[data-tw-fs-panel]').forEach(function (ul) {
          ul.hidden = ul.getAttribute('data-tw-fs-panel') !== id;
        });
        piller.forEach(function (p) { p.setAttribute('aria-pressed', p === pille ? 'true' : 'false'); });
        sek.classList.remove('is-alle-vist');
        opdaterFlere();
      });
    };
    piller.forEach(function (p) {
      p.addEventListener('click', function () { vis(p); });
      // Hent ved hover/fokus, hvis baggrundshentningen ikke er nået dertil endnu
      p.addEventListener('pointerenter', function () { if (p.hasAttribute('data-tw-fs-url')) sikr(p); });
      p.addEventListener('focus', function () { if (p.hasAttribute('data-tw-fs-url')) sikr(p); });
    });
    if (flere) {
      flere.addEventListener('click', function () { sek.classList.add('is-alle-vist'); });
      opdaterFlere();
    }
    efterLoad(function () {
      piller.forEach(function (p) { if (p.hasAttribute('data-tw-fs-url')) sikr(p); });
    });
  });

})();
